export default __webpack_public_path__ + "static/media/workflow-stage-inspection-icon.813bc552.svg";